import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["value", "disabled"]
const _hoisted_2 = ["value"]

import { ref, PropType, watchEffect } from 'vue';
import ValidationLabel from '@/shared/components/ValidationLabel.vue';
import { generateUUID, isNullOrWhitespace } from '@/guiide/ts/utilities';


export default /*@__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
  modelValue: {
    type: [String, null] as PropType<string | null>,
    default: null
  },
  items: { type: Array<string>, required: true },
  isDisabled: { type: Boolean, default: false },
  description: { type: String, default: "" },
  abbreviatedDescription: { type: String, default: "" },
  optional: { type: Boolean, default: false },
  isFormControl: { type: Boolean, default: false },
  classes: { type: String, default: "" },
  styleObject: Object as PropType<Record<string, string | number>>
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

__expose({ isValid });

const inputId = `input-${generateUUID()}`;
const displayValue = ref(props.modelValue?.toString() ?? '');
const label = ref<typeof ValidationLabel>(null);

const updateModel = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;

  if (value === "") {
    emit('update:modelValue', null);
    return;
  }

  emit('update:modelValue', value);
};

watchEffect(() => {
  if (props.modelValue === null) {
    displayValue.value = "";
    return;
  }

  displayValue.value = props.modelValue?.toString() ?? '';
});

function isValid(): boolean {
  label.value.hideAnyWarnings();

  if (props.optional) {
    return true;
  }

  if (isNullOrWhitespace(displayValue.value)) {
    label.value.warn('*');
    return false;
  }

  return true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("select", {
      class: _normalizeClass(["dropdown", __props.classes]),
      value: displayValue.value,
      id: inputId,
      onChange: updateModel,
      disabled: __props.isDisabled,
      style: _normalizeStyle(__props.styleObject)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
        return (_openBlock(), _createElementBlock("option", {
          key: i,
          value: item
        }, _toDisplayString(item), 9, _hoisted_2))
      }), 128))
    ], 46, _hoisted_1),
    _createVNode(ValidationLabel, {
      ref_key: "label",
      ref: label,
      elementId: inputId,
      text: __props.description,
      abbreviatedText: __props.abbreviatedDescription
    }, null, 8, ["text", "abbreviatedText"])
  ], 64))
}
}

})